import {HttpEventType, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {from} from 'rxjs';
import { tap } from 'rxjs/operators'; 
import { msal, endpoint } from '../../../../environments/environment';

@Injectable()
export class Interceptor implements HttpInterceptor {

    constructor() {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        return from(this.acquireApiKey(req, next)).pipe(
           tap(event => {
               if (event.type === HttpEventType.Response) {
                   const headers = event.headers;
                   const nonce = headers.get('Nonce');
                   console.log('Nonce:', nonce);
               }
           })
       );
   }

   private async acquireApiKey(req: HttpRequest<any>, next: HttpHandler) {
       const apiKey = msal.apiKey;
       const messageId = msal.messageId;
       const clientId = msal.clientId;

       let headers = null;
       headers = req.clone({
            setHeaders: {}
        }); 
        
       if (req.url.includes(endpoint.apiUrl)) {
        headers = req.clone({
            setHeaders: {
             'x-api-key': `${apiKey}`,
             'message-id': `${messageId}`,
             'Client-id': `${clientId}`
            }
        });
       }
       
       return next.handle(headers).toPromise();
   }
}
